module.exports = __webpack_public_path__ + "img/reject_rd_gray_70@3x.f3453da7.png";